import { Grid } from '@material-ui/core';
import React from 'react';
import { DownloadOpts, PrintOpts } from '../../hooks/usePrintOrDownload';
import { Download } from './Download';
import { Print } from './Print';

export const DownloadAndPrint = (opts: PrintOpts | DownloadOpts) => {
  return (
    <Grid
      data-print-exclude
      item
      container
      direction="row"
      alignItems="center"
      justify="center"
      spacing={2}
    >
      <Grid item>
        <Download {...opts}></Download>
      </Grid>
      <Grid item>
        <Print {...opts}></Print>
      </Grid>
    </Grid>
  );
};
